export interface TagType {
    id: string;
    name: string;
    slug: string;
    description?: string;
    context: "global" | "product" | "ingredient" | "cms" | "supplier" | "organization" | "packaging";
    color: string;
    active: boolean;
    required: boolean;
    multiple: boolean;
    allowFreeValues?: boolean; // Added for new tag system
    sortOrder: number;
    metadata?: Record<string, any>;
    createdAt: string;
    updatedAt: string;
    company?: {
        id: number;
        name: string;
    };
    values?: TagValue[];
}

export interface TagValue {
    id: string;
    name: string;
    slug: string;
    description?: string;
    color?: string;
    sortOrder: number;
    metadata?: Record<string, any>;
    createdAt: string;
    updatedAt: string;
    tagType?: TagType;
}

// EntityTag interface removed - legacy system no longer used

export interface TagTypeFormData {
    name: string;
    description?: string;
    context: TagType["context"];
    color: string;
    required: boolean;
    multiple: boolean;
    sortOrder: number;
}

export interface TagValueFormData {
    name: string;
    description?: string;
    color?: string;
    sortOrder: number;
    tagTypeId?: string;
}

export type TagContext = "global" | "product" | "ingredient" | "cms" | "supplier" | "organization" | "packaging";

export const TAG_CONTEXTS: TagContext[] = [
    "global",
    "product",
    "ingredient",
    "cms",
    "supplier",
    "organization",
    "packaging",
];

export const TAG_CONTEXT_LABELS: Record<TagContext, string> = {
    global: "Global",
    product: "Product",
    ingredient: "Ingredient",
    cms: "CMS",
    supplier: "Supplier",
    organization: "Organization",
    packaging: "Packaging",
};
